import { Component, Input, OnInit } from '@angular/core';
import { ExerciseContainer } from '../../agenda/agenda.component';
import { DataService } from 'projects/runner/src/app/services/data.service';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';

@Component({
  selector: 'app-agenda-exercise-headline',
  templateUrl: './agenda-exercise-headline.component.html',
  styleUrls: ['./agenda-exercise-headline.component.scss']
})
export class AgendaExerciseHeadlineComponent implements OnInit {

  @Input() container: ExerciseContainer = null;
  @Input() title: string;
  @Input() type: string;
  @Input() group = false;
  @Input() team = false;

  constructor(
    public auth: AuthStateService,
    public data: DataService
  ) { }

  ngOnInit(): void {
    if (this.container) {
      this.container.opened = this.getFromStorage();
    }
  }

  public openContainer(container: ExerciseContainer): void {
    container.opened = true;
    this.saveToStorage();
  }

  public closeContainer(container: ExerciseContainer): void {
    container.opened = false;
    this.saveToStorage();
  }

  public canOpenConference(): boolean {
    const slot = this.container.slots[0];
    return slot &&
      this.type === 'conference' &&
      (
        this.auth.isModerator() ||
        (this.auth.isObserver() && slot.isRunningOrPaused('conference'))
      );
  }

  private saveToStorage(): void {
    localStorage.setItem(this.getStorageId(), this.container.opened ? 'open' : 'closed');
  }

  private getFromStorage(): boolean {
    return localStorage.getItem(this.getStorageId()) === 'open';
  }

  private getStorageId(): string {
    return 'agenda_container_' + this.container.id;
  }

}
